import ApiService from "@/core/services/api.service";
import querystring from "querystring";
import axios from "axios";

const getDefaultState = () => ({
    // Ana veriler
    dashboard_item: {},
    moduleList: {},

    // Eğitimler
    assigned_educations: [],
    highlight_educations: [],
    popular_educations: [],
    expired_educations: [],
    new_trainings: [],
    optional_trainings: [],
    competency_educations: [],
    collections: [],

    // Sosyal
    leader_board: {},
    last_posts: [],

    // Provider içerikleri
    udemy_contents: [],
    coursera_contents: [],
    aeroclass_contents: [],
    linkedin_contents: [],
    harvard_contents: [],

    // Widget assignment'ları (widget_id -> data)
    widget_assignments: {},

    // UI
    loading: false,
    error: null,
});

export default {
    namespaced: true,
    state: getDefaultState(),

    // MUTATIONS
    mutations: {
        SET_DASHBOARD_ITEM(state, data) {
            state.dashboard_item = data;
        },
        SET_MODULE_LIST(state, data) {
            state.moduleList = data;
        },
        SET_ASSIGNED_EDUCATIONS(state, data) {
            state.assigned_educations = data;
        },
        SET_HIGHLIGHT_EDUCATIONS(state, data) {
            state.highlight_educations = data;
        },
        SET_POPULAR_EDUCATIONS(state, data) {
            state.popular_educations = data;
        },
        SET_EXPIRED_EDUCATIONS(state, data) {
            state.expired_educations = data;
        },
        SET_NEW_TRAININGS(state, data) {
            state.new_trainings = data;
        },
        SET_OPTIONAL_TRAININGS(state, data) {
            state.optional_trainings = data;
        },
        SET_COMPETENCY_EDUCATIONS(state, data) {
            state.competency_educations = data;
        },
        SET_COLLECTIONS(state, data) {
            state.collections = data;
        },
        SET_LEADER_BOARD(state, data) {
            state.leader_board = data;
        },
        SET_LAST_POSTS(state, data) {
            state.last_posts = data;
        },
        SET_UDEMY_CONTENTS(state, data) {
            state.udemy_contents = data;
        },
        SET_COURSERA_CONTENTS(state, data) {
            state.coursera_contents = data;
        },
        SET_AEROCLASS_CONTENTS(state, data) {
            state.aeroclass_contents = data;
        },
        SET_LINKEDIN_CONTENTS(state, data) {
            state.linkedin_contents = data;
        },
        SET_HARVARD_CONTENTS(state, data) {
            state.harvard_contents = data;
        },
        SET_WIDGET_ASSIGNMENTS(state, { widgetId, data }) {
            state.widget_assignments = { ...state.widget_assignments, [widgetId]: data };
        },
        SET_LOADING(state, value) {
            state.loading = value;
        },
        SET_ERROR(state, error) {
            state.error = error;
        },
        RESET(state) {
            Object.assign(state, getDefaultState());
        },
    },

    // ACTIONS
    actions: {
        // Ana dashboard verisini çeker
        async fetchDashboardData({ commit }) {
            commit('SET_LOADING', true);
            try {
                const response = await ApiService.get('api/dashboard');
                commit('SET_DASHBOARD_ITEM', response.data);
                commit('SET_ERROR', null);
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            } finally {
                commit('SET_LOADING', false);
            }
        },

        // Widget/modül listesini çeker
        async fetchModuleList({ commit }, companyId) {
            try {
                const response = await axios.get(`${process.env.VUE_APP_BACKEND_APP_URL}/api/widgets`, {
                    params: { company_id: companyId, by_user: true }
                });
                commit('SET_MODULE_LIST', response.data);
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        // Yaklaşan eğitimleri çeker
        async fetchAssignedEducations({ commit }, filters = {}) {
            try {
                const params = {
                    page: 1,
                    perPage: 15,
                    order_by: 'end_date',
                    sort: 'asc',
                    by_user: true,
                    with_expired: false,
                    only_on_progress: false,
                    up_coming_trainings: true,
                    search: filters.search || null,
                    ...filters
                };
                const response = await ApiService.get(`api/assignment?${querystring.stringify(params)}`);
                commit('SET_ASSIGNED_EDUCATIONS', response.data);
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        // Öne çıkan eğitimleri çeker
        async fetchHighlightEducations({ commit }, filters = {}) {
            try {
                const params = {
                    page: 1,
                    perPage: 4,
                    order_by: 'created_at',
                    order: 'desc',
                    by_user: true,
                    with_expired: false,
                    only_on_progress: false,
                    highlight_education: 1,
                    search: filters.search || null,
                    ...filters
                };
                const response = await ApiService.get(`api/assignment?${querystring.stringify(params)}`);
                // Süresi dolmamış olanları filtrele
                const filteredData = response.data.data?.filter(item => !item.is_expired) || [];
                commit('SET_HIGHLIGHT_EDUCATIONS', filteredData);
                return { status: true, data: filteredData };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        // Popüler eğitimleri çeker
        async fetchPopularEducations({ commit }, filters = {}) {
            try {
                const params = {
                    page: 1,
                    perPage: 4,
                    order_by: 'created_at',
                    order: 'desc',
                    by_user: true,
                    with_expired: false,
                    only_on_progress: false,
                    only_popular: true,
                    search: filters.search || null,
                    ...filters
                };
                const response = await ApiService.get(`api/assignment?${querystring.stringify(params)}`);
                commit('SET_POPULAR_EDUCATIONS', response.data);
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        // Süresi dolmuş eğitimleri çeker
        async fetchExpiredEducations({ commit }, filters = {}) {
            try {
                const params = {
                    page: 1,
                    perPage: 4,
                    order_by: 'created_at',
                    order: 'desc',
                    by_user: true,
                    with_expired: true,
                    only_on_progress: false,
                    search: filters.search || null,
                    ...filters
                };
                const response = await ApiService.get(`api/assignment?${querystring.stringify(params)}`);
                commit('SET_EXPIRED_EDUCATIONS', response.data);
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        // Yeni eğitimleri çeker
        async fetchNewTrainings({ commit }, filters = {}) {
            try {
                const params = {
                    page: 1,
                    perPage: 4,
                    sort: 'desc',
                    order: 'id',
                    by_user: true,
                    with_expired: false,
                    ...filters
                };
                const response = await ApiService.get(`api/assignment?${querystring.stringify(params)}`);
                commit('SET_NEW_TRAININGS', response.data);
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        // İsteğe bağlı eğitimleri çeker
        async fetchOptionalTrainings({ commit }) {
            try {
                const params = {
                    can_show_self_registrable_trainings: true,
                    can_register_trainings: true,
                    requests_trainings: true,
                    training_kind_id: 0,
                    training_type_id: 0,
                    order_by: 'name',
                    by_user: true,
                };
                const response = await ApiService.get(`api/training?${querystring.stringify(params)}`);
                // Sadece ilk 4 tanesini al
                const trainings = response.data?.data?.slice(0, 4) || [];
                commit('SET_OPTIONAL_TRAININGS', trainings);
                return { status: true, data: trainings };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        // Yetkinlik eğitimlerini çeker
        async fetchCompetencyEducations({ commit }, filters = {}) {
            try {
                const params = {
                    page: 1,
                    perPage: 4,
                    order_by: 'end_date',
                    sort: 'asc',
                    by_user: true,
                    only_competencies: true,
                    search: filters.search || '',
                    ...filters
                };
                const response = await ApiService.get(`api/assignment?${querystring.stringify(params)}`);
                commit('SET_COMPETENCY_EDUCATIONS', response.data);
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        // Koleksiyonları çeker (collection-all)
        async fetchCollections({ commit }) {
            try {
                const params = {
                    order_by: 'created_at',
                };
                const response = await ApiService.get(`api/collection-all?${querystring.stringify(params)}`);
                const raw = Array.isArray(response.data) ? response.data : (response.data?.data || []);
                const collections = raw.filter(c => c.is_verified !== 0);
                commit('SET_COLLECTIONS', collections);
                return { status: true, data: collections };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        // Lider tablosunu çeker
        async fetchLeaderBoard({ commit }) {
            try {
                const response = await ApiService.get('api/dashboard/leader-board');
                commit('SET_LEADER_BOARD', response.data);
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        // Son paylaşımları çeker
        async fetchLastPosts({ commit }) {
            try {
                const response = await ApiService.get('api/last-posts');
                commit('SET_LAST_POSTS', response.data);
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        //LinkedIn Learning içeriklerini çeker
        async fetchLinkedinContents({ commit }) {
            try {
                const params = { limit: 4, provider: 'linkedin' };
                const response = await ApiService.get(`api/provider-search?${querystring.stringify(params)}`);
                commit('SET_LINKEDIN_CONTENTS', response.data);
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        //Udemy Business içeriklerini çeker
        async fetchUdemyContents({ commit }) {
            try {
                const params = { limit: 4, provider: 'udemy' };
                const response = await ApiService.get(`api/provider-search?${querystring.stringify(params)}`);
                commit('SET_UDEMY_CONTENTS', response.data);
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        //Coursera içeriklerini çeker
        async fetchCourseraContents({ commit }) {
            try {
                const params = { limit: 4, provider: 'coursera' };
                const response = await ApiService.get(`api/provider-search?${querystring.stringify(params)}`);
                commit('SET_COURSERA_CONTENTS', response.data);
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        //Aeroclass içeriklerini çeker
        async fetchAeroclassContents({ commit }) {
            try {
                const params = { limit: 4, provider: 'aeroclass' };
                const response = await ApiService.get(`api/provider-search?${querystring.stringify(params)}`);
                commit('SET_AEROCLASS_CONTENTS', response.data);
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        // Harvard Business içeriklerini çeker
        async fetchHarvardContents({ commit }) {
            try {
                const params = { limit: 4, provider: 'harvard' };
                const response = await ApiService.get(`api/provider-search?${querystring.stringify(params)}`);
                commit('SET_HARVARD_CONTENTS', response.data);
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        // Widget'a bağlı assignment'ları çeker
        async fetchWidgetAssignments({ commit }, widgetId) {
            try {
                const params = {
                    page: 1,
                    perPage: 4,
                    widget_id: widgetId,
                    by_user: true,
                };
                const response = await ApiService.get(`api/assignment?${querystring.stringify(params)}`);
                commit('SET_WIDGET_ASSIGNMENTS', { widgetId, data: response.data });
                return { status: true, data: response.data };
            } catch (error) {
                commit('SET_ERROR', error);
                return { status: false, error };
            }
        },

        resetDashboard({ commit }) {
            commit('RESET');
        },
    },

    getters: {
        // Ana veriler
        dashboardItem: state => state.dashboard_item,
        moduleList: state => state.moduleList,

        // Eğitimler
        assignedEducations: state => state.assigned_educations,
        highlightEducations: state => state.highlight_educations,
        popularEducations: state => state.popular_educations,
        expiredEducations: state => state.expired_educations,
        newTrainings: state => state.new_trainings,
        optionalTrainings: state => state.optional_trainings,
        competencyEducations: state => state.competency_educations,
        collections: state => state.collections,

        // Sosyal
        leaderBoard: state => state.leader_board,
        lastPosts: state => state.last_posts,

        // Provider
        linkedinContents: state => state.linkedin_contents,
        udemyContents: state => state.udemy_contents,
        courseraContents: state => state.coursera_contents,
        aeroclassContents: state => state.aeroclass_contents,
        harvardContents: state => state.harvard_contents,

        // Widget assignments
        widgetAssignments: state => state.widget_assignments,

        // UI
        loading: state => state.loading,
        error: state => state.error,

        // Store'da veri var mı? (Skeleton kontrolü için)
        hasInitialData: state => {
            return Object.keys(state.dashboard_item).length > 0 &&
                Object.keys(state.moduleList).length > 0;
        },
    },
};
